import { useEffect, useState } from "react";
import { formatClock } from "./dates";
import { COUNTDOWN_BREAKS } from "./phoneStatus";

/** Relógio compartilhado: um único setInterval para todos os timers da tela. */
const listeners = new Set<(now: number) => void>();
let tickId: number | null = null;

function subscribeTick(fn: (now: number) => void) {
  listeners.add(fn);
  if (tickId == null) {
    tickId = window.setInterval(() => {
      const now = Date.now();
      listeners.forEach((l) => l(now));
    }, 1000);
  }
  return () => {
    listeners.delete(fn);
    if (!listeners.size && tickId != null) {
      window.clearInterval(tickId);
      tickId = null;
    }
  };
}

export function useNow(enabled = true): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!enabled) return;
    return subscribeTick(setNow);
  }, [enabled]);
  return now;
}

export type TimerValue = { text: string; negative: boolean; countdown: boolean };

/**
 * Regras do DigitalClock (gui) em modo timer:
 * - padrão: tempo decorrido desde `begin`;
 * - pausas "Almoço", "NR1", "NR2", "Almoço SAC": regressivo até o tempo limite
 *   da pausa; ao ultrapassar, mostra o excedente com sinal negativo.
 */
export function computeTimer(begin: Date, now: number, breakName?: string, timeLimitMin = 0): TimerValue {
  const elapsed = Math.max(0, Math.floor((now - begin.getTime()) / 1000));
  const countdown = Boolean(breakName && COUNTDOWN_BREAKS.has(breakName));
  if (!countdown) return { text: formatClock(elapsed), negative: false, countdown };
  const limit = Math.max(0, timeLimitMin) * 60;
  if (elapsed > limit) return { text: `-${formatClock(elapsed - limit)}`, negative: true, countdown };
  return { text: formatClock(limit - elapsed), negative: false, countdown };
}

